import BasePage from "@Scripts/Pages/BasePage";

import DataHelper from "@Scripts/Common/DataHelper";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class MagazinePage extends BasePage {
    public static async init() {
        super.init();

        let vm = this;

        if (navigator.onLine) {
            document.getElementById("MagazineDownloadProgress").classList.add("hden");
            document.getElementById("Offline").classList.add("hden");
            document.getElementById("BannerArea").classList.remove("hden");
            document.body.classList.remove("magazine-toast-active");
        } else {
            document.getElementById("Offline").classList.remove("hden");
            document.getElementById("BannerArea").classList.add("hden");
            document.body.classList.add("magazine-toast-active");
        }

        if (CookieHelper.getCookie("nwsl") && CookieHelper.getCookie("mgznntr")) {
            document.getElementById("MagazineDownloadInfo").classList.add("hden");
            if (navigator.onLine) {
                document.body.classList.remove("magazine-toast-active");
            }
        } else if (CookieHelper.getCookie("nwsl")) {
            document.getElementById("MagazineDownloadInfo").classList.remove("hden");
            document.body.classList.add("magazine-toast-active");
        }

        document.addEventListener("click", (event) => {
            if ((<HTMLElement>event.target).id === "MagazineDownloadButton") {
                CookieHelper.setCookie("mgznntr", "set", 365)
                document.getElementById("MagazineDownloadInfo").classList.add("hden");
                vm.setServiceWorker();

                GTagHelper.sendEvent("file_download", { magazine_file_name: (<HTMLElement>event.target).getAttribute("data-name"), magazine_download_status: "start", link_url: window.location.href });
            }
        });

        window.addEventListener("offline", () => {
            document.getElementById("Offline").classList.remove("hden");
            document.getElementById("BannerArea").classList.add("hden");
            document.body.classList.add("magazine-toast-active");
        });

        window.addEventListener("online", () => {
            document.getElementById("MagazineDownloadProgress").classList.add("hden");
            document.getElementById("Offline").classList.add("hden");
            document.getElementById("BannerArea").classList.remove("hden");
            document.body.classList.remove("magazine-toast-active");
        });
    }

    private static setServiceWorker() {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.register("../../../magazine.serviceworker.js?culture=" + (<any>window).App.culture, { scope: "/" + (<any>window).App.culture.split('-')[0] + "/magazine" });
        }

        navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data.msg !== 100) {
                document.getElementById("MagazineDownloadProgress").classList.remove("hden");

                document.getElementById("MagazineDownloadPercentage").textContent = DataHelper.convertToString(event.data.msg, "Integer") + "%";
                document.body.classList.remove("magazine-toast-active");
            } else {
                document.getElementById("MagazineDownloadProgress").classList.add("hden");
                document.body.classList.remove("magazine-toast-active");

                GTagHelper.sendEvent("file_download", { magazine_file_name: document.querySelector("#MagazineDownloadButton").getAttribute("data-name"), magazine_download_status: "download", link_url: window.location.href });
            }
        });
    };
}